import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type { FieldInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const transactionFields: FieldInterface[] = [
  {
    key: 'type',
    originKey: 'simplified_caption',
    type: FIELD_TYPES.string,
  },
  {
    key: 'date',
    originKey: 'date',
    type: FIELD_TYPES.string,
  },
  {
    key: 'value',
    originKey: 'value',
    type: FIELD_TYPES.number,
  },
]
